
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.275 14.618c-.41.239-.715.56-.93.979-.22.428-.345.947-.345 1.582V20H9v-2.821c0-.903.18-1.744.566-2.497a4.41 4.41 0 011.712-1.798c.769-.44 1.662-.634 2.635-.634h4.174c.916 0 1.84.178 2.64.637a4.338 4.338 0 011.707 1.795c.387.753.566 1.594.566 2.497V20h-2v-2.821c0-.635-.125-1.154-.345-1.582-.215-.42-.52-.74-.93-.979-.399-.228-.93-.368-1.638-.368h-4.174c-.708 0-1.24.14-1.638.368z"}}),_c('path',{attrs:{"d":"M8 13.25v2H5.201c-.549 0-.945.112-1.235.284a1.792 1.792 0 00-.697.763c-.17.342-.269.763-.269 1.286V20H1v-2.417c0-.78.15-1.513.477-2.174a3.855 3.855 0 011.465-1.593c.665-.395 1.434-.566 2.26-.566H8z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 9a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zM7.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 2a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"}})])
          )
        }
      }
    